import * as React from "react";

/// <reference path="../../../Frontend.Core/dist/definitions/NCB.d.ts" />

interface ICurrencySelectProps {
    selectedCurrency: string,
    onSelect: (newCurrency: string) => void
}

interface ICurrencySelectState {
    availableRates: string[]
}

export class CurrencySelect extends React.Component<ICurrencySelectProps, ICurrencySelectState> {

    constructor (props: ICurrencySelectProps) {
        super(props);

        this.props = props;

        let availableRates = NCB.CurrencyHelper.getAvailableCurrencyRates();

        this.state = {
            availableRates: availableRates
        }
    }

    componentWillReceiveProps(nextProps: ICurrencySelectProps) {
        if (nextProps.selectedCurrency !== this.props.selectedCurrency)
            this.forceUpdate();
    }

    refreshAvailableRates = () => {
    }
    
    render() {

        let options = this.state.availableRates.map(x => <option value={x}>{x}</option>);

        return <select className="ncb-currencySelect" value={this.props.selectedCurrency} onChange={(e: any) => this.props.onSelect(e.currentTarget.value)}>
            {options}
        </select>
    }
}


// WEBPACK FOOTER //
// ./src/components/shared/currencySelect.tsx